module.exports = __webpack_public_path__ + "static/media/carruselManualMini.c8ff96ae.png";